import { render, staticRenderFns } from "./OliverSales.vue?vue&type=template&id=cb15712c&scoped=true"
import script from "./OliverSales.vue?vue&type=script&lang=js"
export * from "./OliverSales.vue?vue&type=script&lang=js"
import style0 from "./OliverSales.vue?vue&type=style&index=0&id=cb15712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb15712c",
  null
  
)

export default component.exports